import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Box,
  Tabs,
  Tab,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import { Menu as MenuIcon, Route as RouteIcon, School as StudentIcon } from "@mui/icons-material";

import EmiratesTab from "./EmiratesTab";
import RouteTab from "./RouteTab";
import AreaTab from "./AreaTab";
import BustopTab from "./BustopTab";
import StudentManageTab from "./Tabs/StudentManagement";
import RouteManagementTabs from "./Tabs/RouteManagementTabs";
import PDFManageTab from "./Tabs/PDFManageTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Index = () => {
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [activeSection, setActiveSection] = useState("route");
  const [open, setOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMenuItemClick = (section) => {
    setActiveSection(section);
    handleDrawerClose();
  };

  const token = localStorage.getItem("token");
  console.log("🚀 ~ Index ~ token:", !!!token);

  return (
    <Box sx={{ display: "flex" }}>
      {/* Hamburger Menu Button */}
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{
          position: "fixed",
          left: 15,
          top: 15,
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        {!open && !!token && <MenuIcon />}
      </IconButton>

      {/* Side Drawer Navigation */}
      <Drawer
        variant="temporary"
        open={open}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: 250,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 250,
            boxSizing: "border-box",
          },
        }}
      >
        <List
          sx={{
            paddingTop: "64px", // Add this line to move content down
            paddingX: 2, // Optional: adds some horizontal padding for better spacing
          }}
        >
          <ListItem
            button
            onClick={() => handleMenuItemClick("route")}
            selected={activeSection === "route"}
            sx={{
              borderRadius: 2,
              marginY: 1,
              paddingY: 2,
              display: "flex",
              alignItems: "center",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "& .MuiListItemIcon-root": {
                minWidth: 48,
                marginRight: 2,
              },
              "& .MuiListItemText-primary": {
                fontSize: "1.1rem",
                fontWeight: 500,
              },
            }}
          >
            <ListItemIcon>
              <RouteIcon />
            </ListItemIcon>
            <ListItemText primary="Route Manage" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("student")}
            selected={activeSection === "student"}
            sx={{
              borderRadius: 2,
              marginY: 1,
              paddingY: 2,
              PaddingX: 1,
              display: "flex",
              alignItems: "center",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "& .MuiListItemIcon-root": {
                minWidth: 48,
                marginRight: 2,
              },
              "& .MuiListItemText-primary": {
                fontSize: "1.1rem",
                fontWeight: 500,
              },
            }}
          >
            <ListItemIcon>
              <StudentIcon />
            </ListItemIcon>
            <ListItemText primary="Application Manage " />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("pdf")}
            selected={activeSection === "pdf"}
            sx={{
              borderRadius: 2,
              marginY: 1,
              paddingY: 2,
              PaddingX: 1,
              display: "flex",
              alignItems: "center",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "& .MuiListItemIcon-root": {
                minWidth: 48,
                marginRight: 2,
              },
              "& .MuiListItemText-primary": {
                fontSize: "1.1rem",
                fontWeight: 500,
              },
            }}
          >
            <ListItemIcon>
              <StudentIcon />
            </ListItemIcon>
            <ListItemText primary="PDF Manage " />
          </ListItem>
        </List>
      </Drawer>
      {/* Main Content Area */}

      <Container
        maxWidth={false}
        sx={{
          py: 5,
          px: { xs: 2, sm: 3, md: 4 },
          ml: { xs: 0, sm: open ? "240px" : 0 },
          transition: theme.transitions.create(["margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        {/* Render different sections based on activeSection */}
        {activeSection === "route" && <RouteManagementTabs />}

        {/* Student Management Section */}
        {activeSection === "student" && <StudentManageTab />}

        {/* PDF Management Section */}
        {activeSection === "pdf" && <PDFManageTab />}
      </Container>
    </Box>
  );
};

export default Index;
